/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Proof_3_LInputs */

const en_mk_proof_3_l = /** @type {(inputs: Mk_Proof_3_LInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`track AI usage and set workspace spending limits`)
};

const id_mk_proof_3_l = /** @type {(inputs: Mk_Proof_3_LInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`pantau pemakaian AI dan batasi belanja workspace`)
};

/**
* | output |
* | --- |
* | "track AI usage and set workspace spending limits" |
*
* @param {Mk_Proof_3_LInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_proof_3_l = /** @type {((inputs?: Mk_Proof_3_LInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Proof_3_LInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_proof_3_l(inputs)
	return en_mk_proof_3_l(inputs)
});